<template src="./Message.html"></template>

<script>
import topMenu from "@/components/alert/components/topMenu";
import Pagination from "@/components/components/pagination";
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('alert/message')

export default {
  name: "Statistic",
  data() {
    return {
      showOverlay: false,
      fromDate: null,
      toDate: null,

      fieldsList: [
        {
          key: 'date',
          label: 'Время',
        },
        {
          key: 'type.name',
          label: 'Тип',
        },
        {
          key: 'message',
          label: 'Сообщение',
        },
        {
          key: 'isNew',
          label: 'Статус',
        },
      ]
    }
  },
  components: {
    topMenu,
    Pagination,
  },
  methods: {
    ...mapActions([
        'GET_DATA',
        'SWITCH_TO_READ',
    ]),
    goToPage: function (page) {
      this.$store.commit('alert/message/CURRENT_PAGE', page)
      this.getData()
    },
    perPage: function (page) {
      this.$store.commit('alert/message/PER_PAGE', page)
      this.$store.commit('alert/message/CURRENT_PAGE', 1)
      this.getData()
    },
    initPageSize: function() {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 495) / 25)
      console.log(winHeight)
      this.$store.commit('alert/message/PER_PAGE', winHeight)
      this.$store.commit('alert/message/CURRENT_PAGE', 1)
    },
    getData: function () {
      this.GET_DATA({th: this})
    },
    nFormat: function (number, afterDot = 0) {
      if (number === null || number === '') {
        return 'н/д';
      }
      number = Number(number);
      afterDot = number > 10 ? 0 : afterDot;
      return new Intl.NumberFormat('ru-RU').format(Number((number).toFixed(afterDot)));
    },
  },
  computed: {
    ...mapGetters([
      'DATA',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
    ]),
  },
  watch: {
    fromDate() {
      this.changeDate()
    },
    toDate() {
      this.changeDate()
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('alert') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return;
    }

    this.GET_DATA({th: this})
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
.new-message {
  color: red;
  font-weight: bold;
}
</style>